import React from "react";

// Real MUFT brand assets (trimmed, transparent PNGs).
const ASSETS = {
  full: { light: "/assets/muft_logo_white.png", dark: "/assets/muft_logo_navy.png" },
  symbol: { light: "/assets/muft_symbol_white.png", dark: "/assets/muft_symbol_navy.png" },
};

export const Logo = ({ className = "", light = true, showWord = true, imgClassName = "" }) => {
  const src = showWord
    ? light ? ASSETS.full.light : ASSETS.full.dark
    : light ? ASSETS.symbol.light : ASSETS.symbol.dark;
  return (
    <div className={`flex items-center ${className}`} data-testid="muft-logo">
      <img
        src={src}
        alt="MUFT"
        className={showWord ? `h-7 w-auto ${imgClassName}` : `h-8 w-auto ${imgClassName}`}
        draggable="false"
      />
    </div>
  );
};

export default Logo;
